<script lang="ts">
  let { class: className = '' }: { class?: string } = $props();
</script>

<style>
  .field-separator {
    width: 1px;
    background-color: #e5e7eb;
    margin: 0 0.5rem;
    align-self: stretch; /* Make the line stretch to the height of the row */
  }

  /* Vertical dividers make no sense in the stacked mobile row layout */
  @media (max-width: 639px) {
    .field-separator {
      display: none;
    }
  }
</style>

<div class="field-separator {className}"></div>
